"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var snackbar_1 = require("@material/snackbar");
//@ts-ignore
require("../theme.ts");
var Snackbar = /** @class */ (function (_super) {
    __extends(Snackbar, _super);
    function Snackbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onButtonClick = function (evt) {
            _this.fire('buttonClick');
        };
        _this.onIconButtonClick = function (evt) {
            _this.fire('iconButtonClick');
        };
        return _this;
    }
    Snackbar.prototype.installed = function () {
        var _this = this;
        var snackbar = new snackbar_1.MDCSnackbar(this.shadowRoot.querySelector('.mdc-snackbar'));
        snackbar.listen('MDCSnackbar:opened', function () {
            _this.fire('opened');
        });
        snackbar.listen('MDCSnackbar:closed', function () {
            _this.fire('closed');
            //直接改掉下次需要 diff 的 attr, html 模式下初始化没有这个属性？？
            _this['__omiattr_'] && (_this['__omiattr_'].show = false);
        });
        this.snackbar = snackbar;
        if (this.props.show) {
            this.snackbar.open();
        }
        else {
            this.snackbar.close();
        }
    };
    Snackbar.prototype.updated = function () {
        if (this.props.show) {
            this.snackbar.open();
        }
        else {
            this.snackbar.close();
        }
    };
    Snackbar.prototype.render = function (props) {
        return (omi_1.h("div", __assign({}, omi_1.extractClass(props, 'mdc-snackbar', {
            'mdc-snackbar--stacked': props.stacked,
            'mdc-snackbar--leading': props.leading
        })),
            omi_1.h("div", { class: "mdc-snackbar__surface" },
                omi_1.h("div", { class: "mdc-snackbar__label", role: "status", "aria-live": "polite" }, props.msg),
                omi_1.h("div", { class: "mdc-snackbar__actions" },
                    omi_1.h("button", { onClick: this.onButtonClick, type: "button", class: "mdc-button mdc-snackbar__action" }, props.buttonText),
                    omi_1.h("button", { onClick: this.onIconButtonClick, class: "mdc-icon-button mdc-snackbar__dismiss material-icons", title: "Dismiss", style: "color:white;" }, "close")))));
    };
    Snackbar.css = css;
    Snackbar.defaultProps = {};
    Snackbar.propTypes = {
        show: Boolean,
        stacked: Boolean,
        msg: String,
        buttonText: String,
        leading: Boolean
    };
    Snackbar = __decorate([
        omi_1.tag('m-snackbar')
    ], Snackbar);
    return Snackbar;
}(omi_1.WeElement));
exports.default = Snackbar;
